import {useQueryResultTopContentIds} from '../../hook/useQuery'
import {useTranslation} from '../../hook/useTranslation'
import {formatShortenNumber} from "../../utils/format";
import {useWordPressContents} from '../../hook/useWordPressContents'
import {TopList, TopListItem} from "@octavius-rocks/ui";

const TopPostsWidget = ()=>{
    const i18n = useTranslation("base")
    const {value = []} = useQueryResultTopContentIds()
    const contents = useWordPressContents((value || []).map(({content_id})=> content_id));

    if(!Array.isArray(value)) return null;

    return <TopList>
        {value.map(({content_id, hits, content_type})=>{
            const {
                ID = content_id,
                title = content_id,
                url,
            } = contents[content_id] || {}
            return <TopListItem
                key={ID}
                text={(title)? title: content_type}
                description={`${formatShortenNumber(hits)} ${i18n.hits}`}
                url={url}
            />
        })}
    </TopList>
}

export default TopPostsWidget
